import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { registerLocale } from "react-datepicker";
import { Col, Input, Label, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import { NumericFormat } from "react-number-format";
import TextArea from "antd/es/input/TextArea";
import { ColorPicker } from "antd";
import { updateSection } from "store/section/thunk";
import DropdownAsyncBannerPosition from "components/Common/DropdownAsyncBannerPosition";
import DropdownOptionMulti from "components/Common/DropdownOptionMulti";

registerLocale("en", en);
registerLocale("ko", ko);

const SectionInfoTab = ({ data, handleUpdateSuccess, dataSection }: any) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [listCheckedBannerPosition, setListCheckedBannerPosition] =
    useState<any>(null);

  function normalizeBadgeField(field: any) {
  if (
    !field ||
    (field.content === undefined &&
      field.textColor === undefined &&
      field.textColorSelected === undefined &&
      field.backgroundColor === undefined &&
      field.backgroundColorSelected === undefined)
  ) {
    return null;
  }
  return field;
}

  const handleSubmit = async (values: any) => {
    if (!data?.id) return;

    try {
      setIsLoading((_prev) => true);
      const formatLinkIds = values?.toIds?.length > 0 ? values?.toIds?.map((item: any) => item?.value) : null;
      const formatBadge = normalizeBadgeField(values?.badges);

      const data = {
        ...values,
        price: Number(values?.price),
        priceFinal: Number(values?.priceFinal),
        discountRate: Number(values?.discountRate),
        badges: formatBadge ? [values?.badges] : null,
        toIds: formatLinkIds
      };
      const response: any = await updateSection(data?.id, data);

      if (response?.code === 200) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        handleUpdateSuccess && handleUpdateSuccess();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    iconUrl: Yup.string().required(`${t("This field is required")}`),
    previewUrl: Yup.string().required(`${t("This field is required")}`),
    name: Yup.string().required(`${t("This field is required")}`),
    fullName: Yup.string().required(`${t("This field is required")}`),
    detailName: Yup.string().required(`${t("This field is required")}`),
    description: Yup.string().required(`${t("This field is required")}`),
    price: Yup.number().required(`${t("This field is required")}`),
    discountRate: Yup.number().required(`${t("This field is required")}`),
    priceFinal: Yup.number().required(`${t("This field is required")}`),
    configs: Yup.object({
      maxActiveItems: Yup.number().required(`${t("This field is required")}`),
      displayMode: Yup.string()
        .oneOf(["random", "order"])
        .required(t("This field is required")),
    }),
    // badges: Yup.object({
    //   content: Yup.string().required(`${t("This field is required")}`),
    //   textColor: Yup.string().required(`${t("This field is required")}`),
    //   textColorSelected: Yup.string().required(
    //     `${t("This field is required")}`
    //   ),
    //   backgroundColor: Yup.string().required(`${t("This field is required")}`),
    //   backgroundColorSelected: Yup.string().required(
    //     `${t("This field is required")}`
    //   ),
    // }),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      iconUrl: "",
      previewUrl: "",
      name: "",
      fullName: "",
      detailName: "",
      description: "",
      price: 0,
      discountRate: undefined,
      priceFinal: 0,
      generationInterval: "",
      configs: {
        maxActiveItems: 0,
        displayMode: "random",
      },
      badges: {
        content: "",
        textColor: "",
        textColorSelected: "",
        backgroundColor: "",
        backgroundColorSelected: "",
      },
      bannerPositionIds: null,
      order: null,
      homeScreenOrder: null,
      displayInHomeScreen: true,
      toIds: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (data) {
      const formatLinkFrom = data?.linksFrom?.length > 0 ?  data?.linksFrom?.map((item: any) => ({
        label: item?.to?.fullName,
        value: item?.to?.id
      })) : [];

      const dataBannerPosition = data?.bannerPositions;
      let formatBannerPositionIds = [];
      if (dataBannerPosition?.length > 0) {
        const formatBannerPosition = dataBannerPosition.map((item: any) => ({
          value: item?.bannerPositionId,
          label: (
            <div className="d-flex align-items-center gap-2">
              <div>
                {`${item?.bannerPosition?.name} - `}{" "}
                <small className="text-warning">
                  {item?.bannerPosition?.positionCode}
                </small>
              </div>
            </div>
          ),
          data: item?.bannerPosition,
        }));
        formatBannerPositionIds = dataBannerPosition.map(
          (item: any) => item?.bannerPositionId
        );
        setListCheckedBannerPosition(formatBannerPosition);
      }

      formik.setValues({
        ...data,
        configs: {
          maxActiveItems: data?.configs?.maxActiveItems,
          displayMode: data?.configs?.displayMode,
        },
        badges: {
          content: data?.badges?.[0]?.content,
          textColor: data?.badges?.[0]?.textColor,
          textColorSelected: data?.badges?.[0]?.textColorSelected,
          backgroundColor: data?.badges?.[0]?.backgroundColor,
          backgroundColorSelected: data?.badges?.[0]?.backgroundColorSelected,
        },
        bannerPositionIds: formatBannerPositionIds,
        toIds: formatLinkFrom
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <React.Fragment>
      <form onSubmit={formik.handleSubmit}>
        <Row className="mt-3 px-3">
          {data?.id && (
            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="code" className="form-label">
                  {t("Section Key")} <span className="text-danger">*</span>
                </Label>
                <Input
                  id="code"
                  name="code"
                  type="text"
                  className="form-control"
                  placeholder={t("Section Key")}
                  value={formik?.values?.code}
                  disabled={true}
                />
                {formik.touched.code && formik.errors.code ? (
                  <div className="text-danger mt-2">{formik.errors.code}</div>
                ) : null}
              </div>
            </Col>
          )}

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="iconUrl" className="form-label">
                {t("Icon Url")} <span className="text-danger">*</span>
              </Label>
              <Input
                id="iconUrl"
                name="iconUrl"
                type="text"
                className="form-control"
                placeholder={t("Icon Url")}
                value={formik?.values?.iconUrl}
                onChange={(event: any) => {
                  formik.setFieldValue("iconUrl", event?.target?.value);
                }}
              />
              {formik.touched.iconUrl && formik.errors.iconUrl ? (
                <div className="text-danger mt-2">{formik.errors.iconUrl}</div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="previewUrl" className="form-label">
                {t("Preview Url")} <span className="text-danger">*</span>
              </Label>
              <Input
                id="previewUrl"
                name="previewUrl"
                type="text"
                className="form-control"
                placeholder={t("Preview Url")}
                value={formik?.values?.previewUrl}
                onChange={(event: any) => {
                  formik.setFieldValue("previewUrl", event?.target?.value);
                }}
              />
              {formik.touched.previewUrl && formik.errors.previewUrl ? (
                <div className="text-danger mt-2">
                  {formik.errors.previewUrl}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="name" className="form-label">
                {t("Section Name")} <span className="text-danger">*</span>
              </Label>
              <Input
                name="name"
                type="text"
                className="form-control"
                id="name"
                placeholder={t("Section Name")}
                value={formik?.values?.name}
                onChange={(event: any) => {
                  formik.setFieldValue("name", event?.target?.value);
                }}
              />
              {formik?.touched?.name && formik?.errors?.name ? (
                <div className="text-danger mt-2">{formik?.errors?.name}</div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="fullName" className="form-label">
                {t("Section Full Name")} <span className="text-danger">*</span>
              </Label>
              <Input
                name="fullName"
                type="text"
                className="form-control"
                id="fullName"
                placeholder={t("Section Full Name")}
                value={formik?.values?.fullName}
                onChange={(event: any) => {
                  formik.setFieldValue("fullName", event?.target?.value);
                }}
              />
              {formik?.touched?.fullName && formik?.errors?.fullName ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.fullName}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="detailName" className="form-label">
                {t("Section Detail Name")}{" "}
                <span className="text-danger">*</span>
              </Label>
              <Input
                name="detailName"
                type="text"
                className="form-control"
                id="detailName"
                placeholder={t("Section Detail Name")}
                value={formik?.values?.detailName}
                onChange={(event: any) => {
                  formik.setFieldValue("detailName", event?.target?.value);
                }}
              />
              {formik?.touched?.detailName && formik?.errors?.detailName ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.detailName}
                </div>
              ) : null}
            </div>
          </Col>

          <Col md={6} lg={6}>
            <div className="mb-3">
              <Label htmlFor="displayMode" className="form-label">
                {t("Display Mode")} <span className="text-danger">*</span>
              </Label>
              <div className="d-flex justify-content-start align-items-center">
                <div className="d-flex justify-content-start align-items-center form-check me-3">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="random-mode"
                    id={`random-mode-1`}
                    checked={formik?.values?.configs?.displayMode === "random"}
                    style={{ minWidth: "16px" }}
                    onChange={(event) => {
                      formik.setFieldValue("configs.displayMode", "random");
                    }}
                  />
                  <label
                    className="form-check-label position-relative"
                    htmlFor={`random-mode-1`}
                  >
                    {t("Random")}
                  </label>
                </div>
                <div className="d-flex justify-content-start align-items-center form-check me-3">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="order-mode"
                    id={`order-mode-0`}
                    checked={formik?.values?.configs?.displayMode === "order"}
                    style={{ minWidth: "16px" }}
                    onChange={(event) => {
                      formik.setFieldValue("configs.displayMode", "order");
                    }}
                  />
                  <label
                    className="form-check-label position-relative"
                    htmlFor={`order-mode-0`}
                  >
                    {t("Order")}
                  </label>
                </div>
              </div>
              {formik?.touched?.configs?.displayMode &&
              formik?.errors?.configs?.displayMode ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.configs?.displayMode}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="maxActiveItems" className="form-label">
                {t("Max Active Items")} <span className="text-danger">*</span>
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.configs?.maxActiveItems}
                placeholder={t("Max Active Items")}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return (
                    formattedValue === "" || (floatValue || 0) <= 9999999999
                  );
                }}
                onValueChange={(values: any) => {
                  const { floatValue } = values;
                  formik.setFieldValue("configs.maxActiveItems", floatValue);
                }}
              />
              {formik?.touched?.configs?.maxActiveItems &&
              formik?.errors?.configs?.maxActiveItems ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.configs?.maxActiveItems}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="description" className="form-label">
                {t("Description")} <span className="text-danger">*</span>
              </Label>

              <TextArea
                rows={3}
                value={formik?.values?.description}
                onChange={(event: any) => {
                  formik.setFieldValue("description", event?.target?.value);
                }}
                placeholder={t("Description")}
              />
              {formik?.touched?.description && formik?.errors?.description ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.description}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="price" className="form-label">
                {t("Price")} <span className="text-danger">*</span>
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.price}
                placeholder={t("Amount")}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return (
                    formattedValue === "" || (floatValue || 0) <= 9999999999
                  );
                }}
                onValueChange={(values: any) => {
                  const { floatValue } = values;
                  formik.setFieldValue("price", floatValue);
                }}
              />
              {formik.touched.price && formik.errors.price ? (
                <div className="text-danger mt-2">{formik.errors.price}</div>
              ) : null}
            </div>
          </Col>

          <Col lg={3}>
            <div className="mb-3">
              <Label htmlFor="discountRate" className="form-label">
                {`${t("Discount Rate")} (%)`}
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.discountRate}
                placeholder={`${t("Discount Rate")} (%)`}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return formattedValue === "" || (floatValue || 0) <= 100;
                }}
                disabled={!formik?.values?.price}
                onValueChange={(values: any) => {
                  const { floatValue } = values;
                  formik.setFieldValue("discountRate", floatValue);

                  if (formik?.values?.price) {
                    const price = formik?.values?.price;
                    const final = price - price * ((floatValue || 0) / 100);
                    formik.setFieldValue(
                      "priceFinal",
                      Math.round(final * 100) / 100
                    );
                  }
                }}
              />

              {formik.touched.discountRate && formik.errors.discountRate ? (
                <div className="text-danger mt-2">
                  {formik.errors.discountRate}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={3}>
            <div className="mb-3">
              <Label htmlFor="priceFinal" className="form-label">
                {t("Final Price")}
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.priceFinal}
                placeholder={t("Final Price")}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return (
                    formattedValue === "" || (floatValue || 0) <= 9999999999
                  );
                }}
                disabled={true}
                onValueChange={(values: any) => {}}
              />
              {formik.touched.priceFinal && formik.errors.priceFinal ? (
                <div className="text-danger mt-2">
                  {formik.errors.priceFinal}
                </div>
              ) : null}
            </div>
          </Col>

          <Col md={12} lg={12}>
            <div className="mb-3">
              <Label className="form-label">{t("Banner Position")}</Label>

              <DropdownAsyncBannerPosition
                name="bannerPositionIds"
                onChangeSelect={(e: any) => {
                  setListCheckedBannerPosition(e);

                  if (e?.length > 0) {
                    const formatIds = e?.map((item: any) => item?.value);
                    formik.setFieldValue("bannerPositionIds", formatIds);
                  } else {
                    formik.setFieldValue("bannerPositionIds", []);
                  }
                }}
                isMulti={true}
                placeholder={`${t("Select Banner Position")}...`}
                listCheckedOption={listCheckedBannerPosition}
                isAllOption={false}
                hideSelectedOptions={false}
              />

              {formik.touched.bannerPositionIds &&
              formik.errors.bannerPositionIds ? (
                <div className="text-danger mt-2">
                  {formik.errors.bannerPositionIds}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="maxActiveItems" className="form-label">
                {t("Order Display")}
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.order}
                placeholder={t("Order Display")}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return (
                    formattedValue === "" || (floatValue || 0) <= 9999999999
                  );
                }}
                onValueChange={(values: any) => {
                  const { floatValue } = values;
                  formik.setFieldValue("order", floatValue);
                }}
              />
              {formik?.touched?.order && formik?.errors?.order ? (
                <div className="text-danger mt-2">{formik?.errors?.order}</div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="maxActiveItems" className="form-label">
                {t("Home Screen Order")}
              </Label>
              <NumericFormat
                className="form-control"
                value={formik?.values?.homeScreenOrder}
                placeholder={t("Home Screen Order")}
                allowLeadingZeros
                allowNegative={false}
                thousandSeparator=","
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  return (
                    formattedValue === "" || (floatValue || 0) <= 9999999999
                  );
                }}
                onValueChange={(values: any) => {
                  const { floatValue } = values;
                  formik.setFieldValue("homeScreenOrder", floatValue);
                }}
              />
              {formik?.touched?.homeScreenOrder &&
              formik?.errors?.homeScreenOrder ? (
                <div className="text-danger mt-2">
                  {formik?.errors?.homeScreenOrder}
                </div>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="maxActiveItems" className="form-label">
                {t("Display In Home Screen")}{" "}
                <span className="text-danger">*</span>
              </Label>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <Input
                    name="displayInHomeScreen"
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="directMessage"
                    checked={formik?.values?.displayInHomeScreen}
                    onChange={(event: any) =>
                      formik.setFieldValue(
                        "displayInHomeScreen",
                        event?.target.checked
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="communityDelayRange" className="form-label">
                {t("Badge Info")}
              </Label>

              <Row>
                <Col lg={3}>
                  <div className="mb-1">
                    <Label htmlFor="content" className="form-label">
                      {t("Label Text")}
                    </Label>
                    <Input
                      name="name"
                      type="text"
                      className="form-control"
                      placeholder={t("Label Text")}
                      value={formik?.values?.badges?.content}
                      onChange={(event) =>
                        formik.setFieldValue(
                          "badges.content",
                          event?.target?.value
                        )
                      }
                    />
                    {formik.touched?.badges?.content &&
                    formik.errors?.badges?.content ? (
                      <div className="text-danger mt-2">
                        {formik.errors?.badges?.content}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg={2} className="mt-2">
                  <label className="form-label w-100">
                    {`${t("Text Color")}`}{" "}
                  </label>
                  <ColorPicker
                    defaultValue="#1677ff"
                    showText
                    allowClear
                    onChange={(value) => {
                      // formik.setFieldValue(`color`, value)
                      let color = undefined;
                      if(!value?.cleared) {
                        color = typeof value == "string" ? value : value?.toHexString();
                      }

                      formik.setFieldValue(`badges.textColor`, color);
                    }}
                    value={formik.values?.badges?.textColor}
                  />{" "}
                  {formik.touched.badges?.textColor &&
                  formik.errors.badges?.textColor ? (
                    <div className="text-danger mt-2">
                      {formik.errors.badges?.textColor}
                    </div>
                  ) : null}
                </Col>
                <Col lg={2} className="mt-2">
                  <label className="form-label w-100">
                    {`${t("Text Color Selected")}`}{" "}
                  </label>
                  <ColorPicker
                    defaultValue="#1677ff"
                    showText
                    allowClear
                    onChange={(value) => {
                      // formik.setFieldValue(`color`, value)
                      let color = undefined;
                      if(!value?.cleared) {
                        color = typeof value == "string" ? value : value?.toHexString();
                      }
                      
                      formik.setFieldValue(`badges.textColorSelected`, color);
                    }}
                    value={formik.values?.badges?.textColorSelected}
                  />{" "}
                  {formik.touched.badges?.textColorSelected &&
                  formik.errors.badges?.textColorSelected ? (
                    <div className="text-danger mt-2">
                      {formik.errors.badges?.textColorSelected}
                    </div>
                  ) : null}
                </Col>
                <Col lg={2} className="mt-2">
                  <label className="form-label w-100">
                    {`${t("Background Color")}`}{" "}
                  </label>
                  <ColorPicker
                    defaultValue="#1677ff"
                    showText
                    allowClear
                    onChange={(value) => {
                      // formik.setFieldValue(`color`, value)
                      let color = undefined;
                      if(!value?.cleared) {
                        color = typeof value == "string" ? value : value?.toHexString();
                      }
                      
                      formik.setFieldValue(`badges.backgroundColor`, color);
                    }}
                    value={formik.values?.badges?.backgroundColor}
                  />{" "}
                  {formik.touched.badges?.backgroundColor &&
                  formik.errors.badges?.backgroundColor ? (
                    <div className="text-danger mt-2">
                      {formik.errors.badges?.backgroundColor}
                    </div>
                  ) : null}
                </Col>
                <Col lg={3} className="mt-2">
                  <label className="form-label w-100">
                    {`${t("Background Color Selected")}`}{" "}
                  </label>
                  <ColorPicker
                    defaultValue="#1677ff"
                    showText
                    allowClear
                    onChange={(value) => {
                      // formik.setFieldValue(`color`, value)
                      let color = undefined;
                      if(!value?.cleared) {
                        color = typeof value == "string" ? value : value?.toHexString();
                      }
                      
                      formik.setFieldValue(`badges.backgroundColorSelected`, color);
                    }}
                    value={formik.values?.badges?.backgroundColorSelected}
                  />{" "}
                  {formik.touched.badges?.backgroundColorSelected &&
                  formik.errors.badges?.backgroundColorSelected ? (
                    <div className="text-danger mt-2">
                      {formik.errors.badges?.backgroundColorSelected}
                    </div>
                  ) : null}
                </Col>
              </Row>
            </div>
          </Col>

          <Col lg={12}>
            <Label htmlFor="toIds" className="form-label">
              {t("Section Linked")}
            </Label>
            <DropdownOptionMulti
              name="toIds"
              placeholder={`${t("Section Linked")}...`}
              initialValue={formik?.values?.toIds || null}
              dataList={dataSection || []}
              onChangeSelect={(event: any) => {
                formik.setFieldValue("toIds", event);
              }}
              isHasOptionAll={false}
            />
          </Col>

          <Col lg={12}>
            <div className="hstack gap-2 justify-content-end my-3">
              <button
                className="btn btn-primary fs-14"
                color="success"
                type="submit"
                disabled={isLoading}
                style={{ width: "140px" }}
              >
                {isLoading ? (
                  <Spinner size="sm" className="me-2"></Spinner>
                ) : (
                  <>{t("Update")}</>
                )}
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </React.Fragment>
  );
};

export default SectionInfoTab;
